import { render, staticRenderFns } from "./LiteracyConfig.vue?vue&type=template&id=3c1c140e&scoped=true"
import script from "./LiteracyConfig.vue?vue&type=script&lang=js"
export * from "./LiteracyConfig.vue?vue&type=script&lang=js"
import style0 from "./LiteracyConfig.vue?vue&type=style&index=0&id=3c1c140e&prod&scoped=scoped&lang=less"
import style1 from "./LiteracyConfig.vue?vue&type=style&index=1&id=3c1c140e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1c140e",
  null
  
)

export default component.exports